import { loadStripe } from "@stripe/stripe-js";
import React from "react";

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
);

const handleSubscription = async (event) => {
  // Get Stripe.js instance
  const stripe = await stripePromise;

  // Call your backend to create the Checkout Session
  const response = await fetch("/api/create-checkout-session", {
    method: "POST",
  });

  const session = await response.json();

  console.log(session);

  // When the customer clicks on the button, redirect them to Checkout.
  const result = await stripe.redirectToCheckout({
    sessionId: session.sessionId,
  });

  if (result.error) {
    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `result.error.message`.
    alert(result.error.message);
  }
};

const PaymentComponent = () => (
  <button role='link' onClick={handleSubscription}>
    Subscribe
  </button>
);

export default PaymentComponent;
